module.exports = __webpack_public_path__ + "img/1.cc427c58.jpg";